/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as IndexRouteImport } from "./routes/index";
import { Route as AuthedRouteImport } from "./routes/_authed";
import { Route as LoginRouteImport } from "./routes/login";
import { Route as AuthedGozRouteImport } from "./routes/_authed.goz";
import { Route as AuthedAgentsIndexRouteImport } from "./routes/_authed.agents.index";
import { Route as AuthedAgentsRunIdRouteImport } from "./routes/_authed.agents.$runId";
import { Route as AuthedConversationsConversationIdRouteImport } from "./routes/_authed.conversations.$conversationId";

const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthedRoute = AuthedRouteImport.update({
  id: "/_authed",
  getParentRoute: () => rootRouteImport,
} as any);
const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthedGozRoute = AuthedGozRouteImport.update({
  id: "/goz",
  path: "/goz",
  getParentRoute: () => AuthedRoute,
} as any);
const AuthedAgentsIndexRoute = AuthedAgentsIndexRouteImport.update({
  id: "/agents/",
  path: "/agents/",
  getParentRoute: () => AuthedRoute,
} as any);
const AuthedAgentsRunIdRoute = AuthedAgentsRunIdRouteImport.update({
  id: "/agents/$runId",
  path: "/agents/$runId",
  getParentRoute: () => AuthedRoute,
} as any);
const AuthedConversationsConversationIdRoute =
  AuthedConversationsConversationIdRouteImport.update({
    id: "/conversations/$conversationId",
    path: "/conversations/$conversationId",
    getParentRoute: () => AuthedRoute,
  } as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/login": typeof LoginRoute;
  "/goz": typeof AuthedGozRoute;
  "/agents/$runId": typeof AuthedAgentsRunIdRoute;
  "/conversations/$conversationId": typeof AuthedConversationsConversationIdRoute;
  "/agents/": typeof AuthedAgentsIndexRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/login": typeof LoginRoute;
  "/goz": typeof AuthedGozRoute;
  "/agents/$runId": typeof AuthedAgentsRunIdRoute;
  "/conversations/$conversationId": typeof AuthedConversationsConversationIdRoute;
  "/agents": typeof AuthedAgentsIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/_authed": typeof AuthedRouteWithChildren;
  "/login": typeof LoginRoute;
  "/_authed/goz": typeof AuthedGozRoute;
  "/_authed/agents/$runId": typeof AuthedAgentsRunIdRoute;
  "/_authed/conversations/$conversationId": typeof AuthedConversationsConversationIdRoute;
  "/_authed/agents/": typeof AuthedAgentsIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/login"
    | "/goz"
    | "/agents/$runId"
    | "/conversations/$conversationId"
    | "/agents/";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/login"
    | "/goz"
    | "/agents/$runId"
    | "/conversations/$conversationId"
    | "/agents";
  id:
    | "__root__"
    | "/"
    | "/_authed"
    | "/login"
    | "/_authed/goz"
    | "/_authed/agents/$runId"
    | "/_authed/conversations/$conversationId"
    | "/_authed/agents/";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AuthedRoute: typeof AuthedRouteWithChildren;
  LoginRoute: typeof LoginRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authed": {
      id: "/_authed";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof AuthedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/login": {
      id: "/login";
      path: "/login";
      fullPath: "/login";
      preLoaderRoute: typeof LoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authed/goz": {
      id: "/_authed/goz";
      path: "/goz";
      fullPath: "/goz";
      preLoaderRoute: typeof AuthedGozRouteImport;
      parentRoute: typeof AuthedRoute;
    };
    "/_authed/agents/": {
      id: "/_authed/agents/";
      path: "/agents";
      fullPath: "/agents/";
      preLoaderRoute: typeof AuthedAgentsIndexRouteImport;
      parentRoute: typeof AuthedRoute;
    };
    "/_authed/agents/$runId": {
      id: "/_authed/agents/$runId";
      path: "/agents/$runId";
      fullPath: "/agents/$runId";
      preLoaderRoute: typeof AuthedAgentsRunIdRouteImport;
      parentRoute: typeof AuthedRoute;
    };
    "/_authed/conversations/$conversationId": {
      id: "/_authed/conversations/$conversationId";
      path: "/conversations/$conversationId";
      fullPath: "/conversations/$conversationId";
      preLoaderRoute: typeof AuthedConversationsConversationIdRouteImport;
      parentRoute: typeof AuthedRoute;
    };
  }
}

interface AuthedRouteChildren {
  AuthedGozRoute: typeof AuthedGozRoute;
  AuthedAgentsRunIdRoute: typeof AuthedAgentsRunIdRoute;
  AuthedConversationsConversationIdRoute: typeof AuthedConversationsConversationIdRoute;
  AuthedAgentsIndexRoute: typeof AuthedAgentsIndexRoute;
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedGozRoute: AuthedGozRoute,
  AuthedAgentsRunIdRoute: AuthedAgentsRunIdRoute,
  AuthedConversationsConversationIdRoute:
    AuthedConversationsConversationIdRoute,
  AuthedAgentsIndexRoute: AuthedAgentsIndexRoute,
};

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
